
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"94.411","height":"64.416","viewBox":"0 0 94.411 64.416"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 720"}},[_c('g',{attrs:{"data-name":"Gruppe 679","transform":"translate(-354.245 -87.122)","fill":"none","stroke":"#ffb3a6","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"data-name":"Pfad 633","d":"M417.016 149.538h-55.9a4.882 4.882 0 01-4.867-4.867V93.989a4.881 4.881 0 014.867-4.867h80.677a4.881 4.881 0 014.867 4.867v50.682a4.882 4.882 0 01-4.867 4.867h-6.251","stroke-width":"4"}}),_c('path',{attrs:{"data-name":"Linie 47","stroke-width":"4","d":"M356.245 99.918h90.411"}}),_c('path',{attrs:{"data-name":"Pfad 634","d":"M429.628 129.326a4.643 4.643 0 00-3.8 2 4.646 4.646 0 00-3.8-2 4.847 4.847 0 000 9.69 4.646 4.646 0 003.8-2 4.643 4.643 0 003.8 2 4.847 4.847 0 000-9.69z","stroke-width":"2"}}),_c('rect',{attrs:{"data-name":"Rechteck 338","width":"10.366","height":"8.55","rx":"1.851","transform":"translate(368.906 110.292)","stroke-width":"2"}}),_c('path',{attrs:{"data-name":"Linie 48","stroke-width":"2","d":"M368.961 132.461h18.825"}}),_c('path',{attrs:{"data-name":"Linie 49","stroke-width":"2","d":"M368.906 139.33h7.049"}}),_c('path',{attrs:{"data-name":"Linie 50","stroke-width":"2","d":"M382.257 139.33h17.913"}})])])])
          )
        }
      }
    